<template>
    <SmartLinkItemComponent v-if="model" :id="model.system.id" :component="!model.system.workflow">
        <div class="hero-block" :style="{ backgroundImage: `url('${backgroundImageUrl}')` }">
            <div class="container " :class="{ 'has-overlay-card': hasHeroOverlay }">
                <div class="row">
                    <div class="col-lg-12">
                        <SmartLinkElement :codename="contentTypes.hero.elements.title.codename"
                            :item-id="model.system.id">
                            <h1 class="title" v-if="model?.elements.title.value">
                                {{ model?.elements.title.value }}
                            </h1>
                        </SmartLinkElement>
                        <SmartLinkElement :codename="contentTypes.hero.elements.content.codename"
                            :item-id="model.system.id">
                            <div class="content" v-if="!isEmpty(model?.elements.content.value)">
                                <RichText :value="model?.elements.content.value" />
                            </div>
                        </SmartLinkElement>
                        <CallToAction
                            v-for="cta in pageStore.getListAs<CallToActionModel>(model.elements.callToAction.value)"
                            :model="cta" />
                    </div>
                    <div class="col-lg" v-if="firstOrDefault(model.elements.image.value)">
                        <NuxtImg :src="firstOrDefault(model.elements.image.value)?.url" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
    <div class="hero-block" v-else :style="{ backgroundImage: `url('${backgroundImageUrl}')` }">
        <div class="container " :class="{ 'has-overlay-card': hasHeroOverlay }">
            <div class="row">
                <div class="col-lg-8"></div>
                <div class="col-lg"></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CallToActionModel, HeroModel } from '~/models';
import { firstOrDefault } from '~/utils/first-or-default';
import { isEmpty } from '~/utils/kontent-helper';
import { contentTypes } from '~/models';

const hasHeroOverlay = useState<boolean>('hasHeroOverlay');

const props = defineProps<{ model?: HeroModel }>();
const pageStore = usePageStore();
const siteStore = useSiteStore();

const backgroundImageUrl = computed(() => {
    const customBackgroundImage = firstOrDefault(props.model?.elements.customBackgroundImage.value);
    if (customBackgroundImage) {
        return customBackgroundImage.url;
    }
    else {
        // use default image
        return siteStore.defaultBackgroundHeroImageUrl
    }
});

</script>
